export default "__VITE_ASSET__BexdcSCX__"